import { useCallback, useMemo } from 'react';
import {
  getEffectiveTenantId,
  type TenantPageScope,
  useTenantFilterStore,
} from '../stores/tenantFilter.store';

export function useScopedTenantFilter(scope: TenantPageScope) {
  const globalTenantId = useTenantFilterStore(s => s.globalTenantId);
  const pageOverride = useTenantFilterStore(s => s.pageOverride);
  const setGlobalTenant = useTenantFilterStore(s => s.setGlobalTenant);
  const setPageTenant = useTenantFilterStore(s => s.setPageTenant);

  const effectiveTenantId = useMemo(
    () => getEffectiveTenantId(scope, globalTenantId, pageOverride),
    [scope, globalTenantId, pageOverride]
  );

  const setTenant = useCallback(
    (tenantId: string | null) => setPageTenant(scope, tenantId),
    [scope, setPageTenant]
  );

  return {
    effectiveTenantId,
    globalTenantId,
    setGlobalTenant,
    setTenant,
  };
}

export function useDashboardTenantFilter() {
  const globalTenantId = useTenantFilterStore(s => s.globalTenantId);
  const setGlobalTenant = useTenantFilterStore(s => s.setGlobalTenant);
  return { globalTenantId, setGlobalTenant };
}
